import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {AlertService, SalesPhraseService, StyleService} from "../_services";
import {FormBuilder} from "@angular/forms";
import {Style, StyleLabelType} from "../_models";
import {StyleNewComponent} from "./style-new.component";
import {NgxSmartModalService} from "ngx-smart-modal";

@Component({
  moduleId: module.id.toString(),
  templateUrl: './style-edit.component.html',
  styleUrls: ['./style.component.css', '../preview/preview-form.component.scss']
})
export class StyleEditComponent extends StyleNewComponent implements OnInit {
  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected styleService: StyleService,
    protected alertService: AlertService,
    protected salesPhraseService: SalesPhraseService,
    protected formBuilder: FormBuilder,
    protected modalService: NgxSmartModalService
  ) {
    super(router, location, route, styleService, alertService, salesPhraseService, formBuilder, modalService);
    this.title = 'Edit Theme';
    this.isNew = false;
  }

  ngOnInit() {
    this.loading = true;
    this.editorLoaded = false;
    super.ngOnInit();

    this.data$.subscribe(
      (style: Style) => {
        if (style) {
          this.style = style;
          this.styles = style.styles || {};
          this.form.patchValue({
            name: style.name,
            content: style.content,
            language: style.language,
            header_style: style.header_style,
            footer_style: style.footer_style,
            header_enhanced_mode: style.header_enhanced_mode,
            footer_enhanced_mode: style.footer_enhanced_mode,
            header_enhanced_content: style.header_enhanced_content,
            footer_enhanced_content: style.footer_enhanced_content,
          });

          if (style.variables) {
            this.variableFields.forEach((field, index) => {
              if (field.name in style.variables) {
                this.setVariableValue(index, style.variables[field.name]);
              }
            });
          }

          if (style.labels) {
            this.labelTypes.forEach(type => {
              const labelType = type.value;
              if (style.labels[labelType] && this.labels[labelType]) {
                Object.entries(style.labels[labelType]).forEach(([key, value]) => {
                  if (value) {
                    const index = parseInt(key);

                    if (index.toString() === key && index >= 0 && index <= this.labels[labelType].length) {
                      this.addLabel(labelType, key, value.toString());
                    }
                  }
                });
              }
            });
          }

          this.headerData.style = style.header_style;
          this.headerData.enhanced_content = style.header_enhanced_content;
          this.footerData.style = style.footer_style;
          this.footerData.enhanced_content = style.footer_enhanced_content;
          setTimeout(() => {
            this.loading = false;
            this.editorLoaded = true;
          }, 1000)
        }
      },
      error => {
        this.handleError(error);
        this.loading = false;
        this.editorLoaded = true;
      }
    );
  }

}
